import { useRef } from 'react';

export const useIsInitialLoading = (loading) => {
  const isInitialLoading = useRef(true);
  isInitialLoading.current = isInitialLoading.current && loading;
  return isInitialLoading.current;
};
